module.exports = __webpack_public_path__ + "media/images/plans/ceremony/setplan-2-cf7107352c9e48fa3ccdf19512aae291.png";